const CommitDoc = () => import('./CommitDoc.vue')
const CommitDocDetail = () => import('./CommitDocDetail.vue')
const CommitDocDetailEdit = () => import('./CommitDocDetailEdit.vue')
const DocModule = () => import('./DocModule.vue')
const ModuleDetail = () => import('./ModuleDetail.vue')
const SubDoc = () => import('./SubDoc.vue')
const ServiceOrder = () => import('./ServiceOrder.vue')
const Lawsuit = () => import('./Lawsuit.vue')
const LawyerLetter = () => import('./LawyerLetter.vue')
const LawyerLetterDetail = () => import('./LawyerLetterDetail.vue')
const LawyerLetterDetailEdit = () => import('./LawyerLetterDetailEdit.vue')
const MeetConsult = () => import('./MeetConsult.vue')
const DraftDoc = () => import('./DraftDoc.vue')


export {
  CommitDoc,
  CommitDocDetail,
  CommitDocDetailEdit,
  DocModule,
  ModuleDetail,
  SubDoc,
  ServiceOrder,
  Lawsuit,
  LawyerLetter,
  LawyerLetterDetail,
  LawyerLetterDetailEdit,
  MeetConsult,
  DraftDoc
}



// WEBPACK FOOTER //
// ./src/pages/doc/index.js